<template>
  <BQdtCard
    name="analyticsTitle"
    type="header-item"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'CustomsValueHeader',

  components: { BQdtCard },
}
</script>
